<template>
  <div>
    <el-card class="mat12">
      <ul class="photos_list">
        <li
          class="photos_item"
          v-for="(item, index) in images"
          :key="index"
          :class="{'contrast':isCheck}"
        >
          <div style="text-align: left;" slot="reference">
            <span v-if="isCheck">*</span>
            <h4>{{item.name}}</h4>

            <!-- 实现点击实现 -->
            <el-popover placement="right-end" width="400" trigger="click">
              <i class="el-icon-view view_history" v-if="isCheck" slot="reference"></i>
              <!-- 这是要点击以后显示的内容 -->
              <div>
                <p>{{item.name}}</p>
                <el-image :src="item.url?item.url:card_img2" class="app-image"></el-image>
              </div>
            </el-popover>
          </div>

          <div
            :class="['photos_item_style', {'photos_item_prosen':item.name === '头像照片' ||item.name === '全身照' }]"
          >
           <el-image
              :src="item.url?item.url:card_img2"
              :preview-src-list="getSrcList(index)"
              class="app-image"
              v-if="item.name === '头像照片' ||item.name === '全身照'"
            ></el-image>
            <el-image
              :src="item.url?item.url:card_img1"
              :preview-src-list="getSrcList(index)"
              class="app-image"
              v-else
            ></el-image>
          </div>
          <!-- <div class="check_card_info" v-if="item.name == '身份证' && examine" >
            <div class="check_btn" @click="handleCheckCard(item.url)">
              <img src="./../../../assets/check.png" class="check_img" />校验身份信息
            </div>
             <div class="check_txt" :class="{'check_txt_error':status}">{{check_txt}}</div>
          </div> -->
         
        </li>
      </ul>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CardImage",
  props: {
    staffDetail: {
      type: Object,
      default: {}
    },
    examine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    images() {
      let arr = [
        {
          name: "头像照片",
          url: this.staffDetail.staffBasis.photo,
          id: "popover1"
        },
        {
          name: "全身照",
          url: this.staffDetail.staffBasis.bodyPic,
          id: "popover2"
        },
        {
          name: "身份证",
          url: this.staffDetail.staffBasis.idPic,
          id: "popover3"
        },
        {
          name: "银行卡",
          url: this.staffDetail.staffBasis.bankcardPic,
          id: "popover4"
        },
        {
          name: "中控证",
          url: this.staffDetail.staffBasis.centralControl,
          id: "popover5"
        },
        {
          name: "保安资格证",
          url: this.staffDetail.staffBasis.securityStafPic,
          id: "popover6"
        },
        {
          name: "健康证",
          url: this.staffDetail.staffBasis.health,
          id: "popover7"
        }
      ];
      return arr;
    }
  },
  created() {
    // console.log(this.staffDetail)
  },
  data() {
    return {
      card_img1: require("@/assets/default_card1.png"),
      card_img2: require("@/assets/default_card2.png"),
      isCheck: false,
      status:false,
      check_txt: "" // 提示语句
    };
  },
  methods: {
    // preview(index) {
    // 之前的放大图片，改为element的写法
    //   console.log(index);
    //   // let src = this.images.map(item => {
    //   //   return item.url;
    //   // });
    //   // this.$imagePreview({
    //   //   images: src,
    //   //   index: index
    //   // });
    // }
    getSrcList(index) {
      let src = this.images.map(item => {
        return item.url;
      });
      // 相当于。删除当前下标获取的数组，  相当于删除的那个元素
      // 表示从当前下标开始，到x结束，没有end，就从开始到全部
      return src.slice(index).concat(src.slice(0, index));
    },
    // 校验
    handleCheckCard(val){
      console.log(val)
      this.status = !this.status;
      this.check_txt="这个是校验身份证操作"
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #409eff;
$hoverBg: #59a5f3;
$sucColor:#67c23a;
$errorColor:#ff0505;
.contrast {
  color: $color;
}
.view_history {
  cursor: pointer;
  margin-left: 10px;
}

.photos_list {
  display: flex;
  list-style: none;
  text-align: center;
  flex-wrap: wrap;
  .photos_item {
    margin-right: 20px;
    margin-bottom: 40px;
    position: relative;
  }
}

.photos_item_style {
  height: 130px;
  width: 230px;
  margin-top: 10px;
  line-height: 130px;
  text-align: center;
}
.photos_item_style .app-image {
  height: 130px;
  width: 230px;
  margin-top: 10px;
  line-height: 130px;
  text-align: center;
}

.photos_item_prosen,
.photos_item_prosen .app-image {
  width: 84px;
}
// 校验
.check_card_info {
  position: absolute;
  bottom: -10px;
  z-index: 1;
  background: $color;
  width: 230px;
  height: 32px;
  &:hover {
    background: $hoverBg;
  }
  .check_btn {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .check_txt {
    padding-top: 5px;
    font-size: 12px;
    color: $sucColor;
  }
  .check_txt_error {
    color: $errorColor;
  }
}
</style>